import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { LicenseCheckDisplayData } from "@/pages/license-check-admin/models/LicenseCheckDisplayData";

export function KeyCell(props: GridRenderCellParams<LicenseCheckDisplayData>) {
  return <>{props.formattedValue || "---"}</>;
}
